import { createSlice } from "@reduxjs/toolkit";
import { IDistributor } from "../interface/IDistributor";

const initialState: IDistributor | null = null;

const distributorSlice = createSlice({
  name: "distributor",
  initialState,
  reducers: {
    setDistributorInStore: (state, action) => {
      return action.payload;
    },
  },
});

export const { setDistributorInStore } = distributorSlice.actions;

export default distributorSlice.reducer;